import topaz from "../assets/topaz.png";
import cobis from "../assets/cobis.png";
import crk from "../assets/crk.png";

export default function getLogo (logo) {
  switch (logo) {
    case 'cobis':
      return cobis
    case 'crk':
      return crk
    default:
      return topaz
  };
};